import { NotificationBell } from './NotificationBell';
import { PropertySelector } from './PropertySelector';
import { shellHeaderClass } from './shellLayout';
import { UserMenu } from './UserMenu';

type TopBarProps = {
  showPropertySelector?: boolean;
};

export function TopBar({ showPropertySelector = true }: TopBarProps) {
  return (
    <header
      className={`sticky top-0 z-30 bg-manejai-cream/95 backdrop-blur-md ${shellHeaderClass}`}
    >
      <div className="flex h-full items-center justify-between gap-4 px-4 sm:px-6 lg:px-8 w-full">
        {showPropertySelector ? (
          <div className="flex items-center gap-3 min-w-0">
            <span className="hidden sm:inline text-xs font-semibold uppercase tracking-wide text-manejai-bark/50 shrink-0">
              Fazenda ativa
            </span>
            <div className="w-44 sm:w-56 md:w-64">
              <PropertySelector />
            </div>
          </div>
        ) : (
          <div />
        )}
        <div className="flex items-center gap-2 shrink-0">
          <NotificationBell />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
